// src/components/layout/Footer.tsx
import { Link } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="w-full bg-gray-900 border-t border-gray-800">
      <div className="max-w-4xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-8">
          {/* Website Info Section */}
          <div className="space-y-6 md:col-span-1">
            <h3 className="text-2xl font-bold bg-gradient-to-r from-purple-400 to-blue-400 bg-clip-text text-transparent">
              WS Online
            </h3>
            <div className="space-y-2">
              <p className="text-gray-300 font-medium">Full Screen Tool</p>
              <ul className="space-y-1.5 text-gray-400 text-sm leading-relaxed">
                <li className="hover:text-purple-400 transition-colors">Herramienta de Pantalla Completa</li>
                <li className="hover:text-purple-400 transition-colors">Outil Plein Écran</li>
                <li className="hover:text-purple-400 transition-colors">Vollbild Werkzeug</li>
                <li className="hover:text-purple-400 transition-colors">Strumento Schermo Intero</li>
                <li className="hover:text-purple-400 transition-colors">Narzędzie Pełnoekranowe</li>
                <li className="hover:text-purple-400 transition-colors">Ferramenta Tela Cheia</li>
                <li className="hover:text-purple-400 transition-colors">Volledig Scherm Hulpmiddel</li>
                <li className="hover:text-purple-400 transition-colors">フルスクリーンツール</li>
              </ul>
            </div>
          </div>

          {/* Legal Section */}
          <div className="space-y-4">
            <h3 className="font-semibold text-purple-400">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy" className="text-gray-300 hover:text-purple-400 transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-300 hover:text-purple-400 transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/gdpr" className="text-gray-300 hover:text-purple-400 transition-colors">
                  GDPR
                </Link>
              </li>
            </ul>
          </div>

          {/* Support Section */}
          <div className="space-y-4">
            <h3 className="font-semibold text-blue-400">Support</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-purple-400 transition-colors">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-gray-300 hover:text-purple-400 transition-colors">
                  FAQ
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Copyright Section */}
        <div className="flex items-center justify-center pt-8 border-t border-gray-800">
          <p className="text-gray-300">
            © {currentYear} WS Online. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;